/**
 * Skeleton placeholder displayed while a lazy-loaded custom workspace view
 * is being fetched. Used as the `loading` option in next/dynamic.
 */
export function WorkspaceViewSkeleton() {
  return (
    <div className="animate-pulse space-y-6 pt-8">
      {/* Header skeleton */}
      <div className="flex items-center gap-3">
        <div className="h-8 w-8 rounded bg-muted" />
        <div className="space-y-2">
          <div className="h-6 w-48 rounded bg-muted" />
          <div className="h-4 w-64 rounded bg-muted" />
        </div>
      </div>

      {/* Settings section skeleton */}
      <div className="space-y-3">
        <div className="h-5 w-32 rounded bg-muted" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="h-20 rounded-lg bg-muted" />
          <div className="h-20 rounded-lg bg-muted" />
        </div>
      </div>

      {/* App catalog skeleton */}
      <div className="space-y-3">
        <div className="h-5 w-24 rounded bg-muted" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="h-36 rounded-lg bg-muted" />
          <div className="h-36 rounded-lg bg-muted" />
          <div className="h-36 rounded-lg bg-muted" />
        </div>
      </div>
    </div>
  );
}
